const TYPE_LENGTH = 3;
const NUMBER_LENGTH = 10;

/**
 * Identifies a card issued for use in the CRTM network. The fields
 * can uniquely identify the card, but the actual card ID contains
 * an issuer, a manufacturer, a pre-personalizer, a personalizer
 * (here called `type`), and a card number (`number`).
 *
 * A card may contain multiple fares.
 */
export type CardId = {
  type: string;
  number: string;
};

/**
 * Returns whether the given card is valid. This method does
 * not check whether the card is enabled and can be used.
 *
 * @param card the card to check
 * @returns true if the card is valid
 */
function isValidCard(card: CardId): boolean {
  return (
    card.type.length === TYPE_LENGTH && card.number.length === NUMBER_LENGTH
  );
}

export { isValidCard };
